// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768px","container":"TextAndText_container__S0wDJ","textContainer":"TextAndText_textContainer__Ackg5"};